import * as React from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import PropTypes from 'prop-types';
import { withStyles, Typography } from '@material-ui/core';

import { TopActionBar, VimoTaskContent, TaskName } from '../../common/components';
import urls from '../../app/urls';

const styles = theme => ({
    root: {

    },
    title: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(4),

        '@media print': {
            padding: theme.spacing(1, 4),
        },
    },
    content: {
        padding: theme.spacing(4),

        '@media print': {
            padding: theme.spacing(1, 4),
        },
    },
});

class Task extends React.Component {
    render() {
        const {
            translate, classes, taskData, skillData,
        } = this.props;

        if (!taskData || !skillData) {
            return null;
        }

        return (
            <div className={classes.root}>
                <TopActionBar
                    title={skillData.name}
                    backLink={{
                        to: `${urls.inside.program.skill}/${skillData.id}`,
                        text: translate('program.backToSkill'),
                    }}
                />

                <Typography variant="h6" className={classes.title}>
                    <TaskName task={taskData} />
                </Typography>

                <div className={classes.content}>
                    <VimoTaskContent
                        task={taskData}
                    />
                </div>
            </div>
        );
    }
}

Task.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            skillId: PropTypes.string.isRequired,
            taskId: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    taskData: PropTypes.object,
    skillData: PropTypes.object,
};

Task.defaultProps = {
    skillData: null,
    taskData: null,
};

const mapStateToProps = (state, ownProps) => ({
    translate: getTranslate(state.localize),
    taskData: state.program.taskDetails && state.program.taskDetails[ownProps.match.params.taskId],
    skillData: state.program.skillDetails && state.program.skillDetails[ownProps.match.params.skillId],
});

export default connect(mapStateToProps)(withStyles(styles)(Task));
